exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".deploy-backup-container[data-v-b7a6f46c]{margin:.75rem}.deploy-backup-container>div.img-container[data-v-b7a6f46c]{margin:.75rem;display:flex;justify-content:center;align-items:center}.deploy-backup-container>div.img-container>img[data-v-b7a6f46c]{width:100px}.deploy-backup-container>button[data-v-b7a6f46c]{margin-top:.75rem}", ""]);

// exports
